import React from "react";
import ConceptLogo from "../assets/images/conceptbiu-logo.png";

export default function Privacy() {
  return (
    <>
      <div className="cmsContainer">
        <div className="cmsHeader">
          <div className="container">
            <img
              src={ConceptLogo}
              alt="Concept BIU"
              width="65"
              height="65"
            />
          </div>
        </div>
        <div className="cmsMainSection">
          <div className="container">
            <div className="cmsSectionInner">
              <h2 className="heading">Privacy Policy</h2>
              <p>
                This Privacy Policy governs the manner in which Concept BIU a
                unit of{" "}
                <strong>NIQX INFORMATICS AND ANALYSIS PRIVATE LIMITED</strong>
                ("NIQX") collects, uses, maintains and discloses information
                collected and reviewed from{" "}
                <a href="http://www.conceptbiu.com/">www.conceptbiu.com</a>{" "}
                website ("Portal"). This privacy policy applies to the Portal
                and all products and services offered by NIQX.
              </p>
              <h2>Identification information</h2>
              <p>
                We may collect subscriber identification information from Users
                in a variety of ways, including, but not limited to, when Users
                visit our site, register on the site, subscribe to the news
                digest, and in connection with other activities, services,
                features or resources we make available on our Portal. Users may
                be asked for, as appropriate, name, email address, phone number
                and other relevant information. Users may, however, visit our
                Portal anonymously. We will collect personal identification
                information from Users only if they voluntarily submit such
                information to us. Users can always refuse to supply personally
                identification information, except that it may prevent them from
                engaging in certain Portal related activities.
              </p>
              <h2>Non-personal identification information</h2>
              <p>
                We may collect non-personal identification information about
                Users whenever they interact with our Portal. Non-personal
                identification information may include the browser name, the
                type of computer and technical information about Users means of
                connection to our Portal, such as the operating system and the
                Internet service providers utilized and other similar
                information.
              </p>
              <h2>Web browser cookies</h2>
              <p>
                Our Portal may use "cookies" to enhance User experience. User's
                web browser places cookies on their hard drive for
                record-keeping purposes and sometimes to track information about
                them. User may choose to set their web browser to refuse
                cookies, or to alert you when cookies are being sent. If they do
                so, note that some parts of the Portal may not function
                properly.
              </p>
              <h2>How we use collected information</h2>
              <p>
                NIQX may collect and use Users information for the following
                purposes:
                <br />
                - To improve customer service <br />
                Information you provide helps us respond to your customer
                service requests and support needs more efficiently.
                <br />
                - To personalize user experience <br />
                We may use information in the aggregate to understand how our
                Users as a group use the services and resources provided on our
                Portal.
                <br />- To improve our Portal
                <br /> We may use feedback you provide to improve our products
                and services.
              </p>
              <h2>How we protect your information</h2>
              <p>
                We adopt appropriate data collection, storage and processing
                practices and security measures to protect against unauthorized
                access, alteration, disclosure or destruction of your
                information, username, password, transaction information and
                data stored on our Portal.
              </p>
              <h2>Changes to this privacy policy</h2>
              <p>
                NIQX has the discretion to update this privacy policy at any
                time. We encourage Users to frequently check this page for any
                changes to stay informed about how we are helping to protect
                their information. You acknowledge and agree that it is your
                responsibility to review this privacy policy periodically and
                become aware of modifications.
              </p>
              <h2>Third Party Policies</h2>
              <p>
                Upon accepting Terms and accessing the Services, You also agree
                to be bound by the Google Privacy Policy, which can be found at{" "}
                <a href="http://www.google.com/policies/privacy">
                  http://www.google.com/policies/privacy
                </a>{" "}
                and is incorporated herein by this reference.
              </p>
              <h2>Your acceptance of these terms</h2>
              <p>
                By using this Portal, you signify your acceptance of this
                policy. If you do not agree to this policy, please do not use
                our Portal. Your continued use of the Portal following the
                posting of changes to this policy will be deemed your acceptance
                of those changes.
              </p>
              <h2>Contacting Us</h2>
              <p>
                <strong>
                  If you have any questions about this Privacy Policy, the
                  practices of this site, or your dealings with this site,
                  please contact us at:
                </strong>
              </p>
              <p>
                <strong className="redText">Concept BIU</strong>
                <br />
                <strong>A 42 F.I.E.E. Complex,</strong>
                <br />
                <strong>Okhla Phase 2,</strong>
                <br />
                <strong>New Delhi - 110020</strong>
                <br />
                <strong>India</strong>
                <br />
                <strong>
                  Email: 
                  <a href="mailto:info@conceptbiu.com">info@conceptbiu.com</a>
                </strong>
                <br />
                <strong>
                  Website: 
                  <a href="http://www.conceptbiu.com/">www.cocneptbiu.com</a>
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
